import * as React from "react";
import * as _ from "lodash";
import {ISymptom} from "@curefit/care-common";
import {default as CustomHeader, ICustomHeaderInfo} from "../../utils/CustomHeader";
import {AppConstants} from "../../../utils/AppConstants";

/**
 * Created by abhinav on 28/01/18.
 */

export interface PatientIllnessViewProps {
    illness: ISymptom[];
}

let PresentingIllnessEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "presentingIllness", display: "HISTORY OF PRESENTING ILLNESS"},
    {label: "days", display: "NO. OF DAYS"},
    {label: "attributes", display: "ATTRIBUTES (IF ANY)"}
];

class PatientIllnessView extends React.Component<PatientIllnessViewProps> {

    constructor(props: PatientIllnessViewProps) {
        super(props);
    }

    render() {
        return (
            <div className="patient-symptom-view">
                {
                    !_.isEmpty(this.props.illness) &&
                    <div>
                        <CustomHeader headerInfos={PresentingIllnessEditorHeaderInfos} rootCls={"patient-symptom"}/>
                        {
                            _.map(this.props.illness, function(symptom: ISymptom, index: number){
                                return (
                                    <div className="symptom-row" key={index}>
                                        <div className="symptom-name">{symptom.displayValue}</div>
                                        <div className={"symptom-days"}>{!_.isEmpty(symptom.duration) ? `${symptom.duration.count} ${AppConstants.FrequencyUnit[symptom.duration.unit]}` : ""}</div>
                                        <div className={"symptom-comment"}>{symptom.comment}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {
                    _.isEmpty(this.props.illness) &&
                    <div>No illnesses to show</div>
                }
            </div>
        );
    }
}

export default PatientIllnessView